module.exports = __webpack_public_path__ + "img/notice-alert.6efbb220.svg";